import { render } from "./settlement-daily.vue?vue&type=template&id=4da8c181"
import script from "./settlement-daily.vue?vue&type=script&lang=js"
export * from "./settlement-daily.vue?vue&type=script&lang=js"

import exportComponent from "/home/Work/max/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__